import moment from "moment";
import { getParticipantFlags } from "@/services/api/ParticipantFlagsServiceApi";
import {getDefaultValueFilterInputs} from "@/services/api/FiltersServiceApi";

const PARTICIPANT_FLAGS_LOCAL_STORAGE_KEY = "PARTICIPANT_FLAGS_";

const DEFAULT_STATE = {
  flags: {
    HABILITA_CARTA_CREDITO: 0,
    ENABLE_STOCK_DOWNLOAD: 0,
  },
  minMaxFilterInputs: {
      yearMax: '',
      yearMin: '',
      kmMax: '',
      kmMin: '',
      priceMax: '',
      priceMin: '',
  },
};

const participantFlagsModule = {
  namespaced: true,
  state() {
    return DEFAULT_STATE;
  },
  mutations: {
    setFlags(state, participantFlags) {
      if (!participantFlags || !Array.isArray(participantFlags)) {
        return;
      }
      
      let flags = participantFlags.map( x => {
          let ob = {};
          ob[x.flag] = x.value;
        return ob
      });

      state.flags = Object.assign({}, ...flags);
    },
    setMinMaxInputs(state, filterInputs) {
        state.minMaxFilterInputs.yearMin = filterInputs.ano_min || '';
        state.minMaxFilterInputs.yearMax = filterInputs.ano_max || '';
        state.minMaxFilterInputs.kmMin = filterInputs.km_min || '';
        state.minMaxFilterInputs.kmMax = filterInputs.km_max || '';
        state.minMaxFilterInputs.priceMin = filterInputs.valor_min || '';
        state.minMaxFilterInputs.priceMax = filterInputs.valor_max || '';
    }
  },
  actions: {
    getParticipantFlags({ commit }) {
      const participantFlagsOftheLocalStorage = localStorage.getItem(
        PARTICIPANT_FLAGS_LOCAL_STORAGE_KEY
      );
      let participantFlagsFromCache =
        typeof participantFlagsOftheLocalStorage == "string"
          ? JSON.parse(participantFlagsOftheLocalStorage)
          : false;

      if (participantFlagsFromCache) {
        const { expires } = participantFlagsFromCache;
        if (moment() > moment(expires)) {
          localStorage.removeItem(PARTICIPANT_FLAGS_LOCAL_STORAGE_KEY);
          participantFlagsFromCache = false;
        }
        if (moment() <= moment(expires)) {
          commit("setFlags", participantFlagsFromCache);
          return;
        }
      }
      if (!participantFlagsFromCache) {
        getParticipantFlags().then((participantFlags) => {
          commit("setFlags", participantFlags);
        });
      }
    },
    async getDefaultValueFilterInputs({ commit }) {
        await getDefaultValueFilterInputs()
                .then((response) => {
                  commit("setMinMaxInputs", response);
                });
    },
  },
};

export default participantFlagsModule;
